import React, { useState, useEffect } from "react";
import SpinnerLoading from "../../components/spinnerLoading/SpinnerLoading";
import { CareerListModel } from "../../../domain/entities/CareerListModel";
import { fetchCareer } from "../../../domain/usecases/fetchListCareer";
import CareerList from "../../components/careerSection/CareerList";

const CareerPage: React.FC = () => {

    const DefaultResponse: CareerListModel = new CareerListModel([]);
    const [careers, setCareers] = useState<CareerListModel>(DefaultResponse);
    const [loading, setLoading] = useState(true); // State for loading
    const [error, setError] = useState<string | null>(null); // State for errors

    useEffect(() => {
        const fetchCareers = async () => {
            try {
                const careerData = await fetchCareer(); // Fetch category products
                setCareers(careerData); // Set categories in state
            } catch (err) {
                console.error("Failed to fetch career:", err);
                setError("Failed to load career. Please try again later.");
            } finally {
                setLoading(false); // End loading
            }
        };

        setTimeout(() => setLoading(false), 2000);
        fetchCareers();
    }, []); // Runs only once on component mount

    if (loading) {
        return <SpinnerLoading />;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div className="flex flex-col justify-center mt-12">
            <h2 className="text-5xl font-bold text-black mt-4 md:mt-6 font-poppins text-center">Karir</h2>
            <p className="text-sm font-light text-gray-400 mt-2 md:mt-4 mb-4 md:mx-96 font-poppins text-center">Bergabunglah dengan Life Media dan menjadi bagian dari tim profesional yang inovatif, berkembang, serta berkomitmen untuk memberikan solusi digital unggul.</p>
            <CareerList careers={careers} />
        </div>
    );
}

export default CareerPage;